﻿import { AdminMetricCard } from "@/components/admin";
import type { AdminStatusTone } from "@/lib/adminCodeDisplay";
import type { EmergencyEventItem, NotificationLogItem } from "@/types.ts";

interface EmergencySummaryCardsProps {
  events: EmergencyEventItem[];
  notificationLogs: NotificationLogItem[];
}

interface EmergencySummaryCard {
  title: string;
  value: string;
  badge: string;
  description: string;
  tone: AdminStatusTone;
  icon: string;
}

const EmergencySummaryCards = ({ events, notificationLogs }: EmergencySummaryCardsProps) => {
  const openCount = events.filter((event) => event.eventStatus === "OPEN").length;
  const inProgressCount = events.filter((event) => ["ACKNOWLEDGED", "IN_PROGRESS"].includes(event.eventStatus)).length;
  const resolvedCount = events.filter((event) => event.eventStatus === "RESOLVED").length;
  const sentLogCount = notificationLogs.filter((log) => log.sendStatus === "SENT" || log.sendStatus === "SUCCESS").length;
  const cards: EmergencySummaryCard[] = [
    {
      title: "미처리 이벤트",
      value: `${openCount}건`,
      badge: "즉시 확인",
      description: "미처리 상태",
      tone: openCount > 0 ? "red" : "emerald",
      icon: "ri-alarm-warning-line",
    },
    {
      title: "확인/처리 중",
      value: `${inProgressCount}건`,
      badge: "진행 중",
      description: "확인 또는 처리 중",
      tone: inProgressCount > 0 ? "orange" : "emerald",
      icon: "ri-loader-4-line",
    },
    {
      title: "처리 완료",
      value: `${resolvedCount}건`,
      badge: "완료",
      description: "현재 목록 기준",
      tone: "emerald",
      icon: "ri-checkbox-circle-line",
    },
    {
      title: "알림 발송",
      value: `${notificationLogs.length}건`,
      badge: "선택 이벤트",
      description: `성공 ${sentLogCount}건`,
      tone: "blue",
      icon: "ri-notification-3-line",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <AdminMetricCard
          key={card.title}
          title={card.title}
          value={card.value}
          badge={card.badge}
          description={card.description}
          tone={card.tone}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default EmergencySummaryCards;
